<template>
  <div class="py-2 px-4 wrapper">
    <div v-if="interactions.length === 0" class="empty-state pa-2 ">
      No interactions created
    </div>
    <!-- @mouseover="setActive(interaction)" -->
    <div v-for="(interaction, index) in interactions" v-else :key="interaction._id" class="my-2">
      <div
        v-if="interaction.from.asset && interaction.to.asset"
        :class="
          `layout new-interaction pa-2 align-center ${
            active &&
            interaction &&
            active._id === interaction._id &&
            interaction.from.asset &&
            interaction.from.asset._id === slide._id
              ? 'active'
              : ''
          }`
        "
      >
        <div class="from">
          <div
            v-if="interaction.from.asset && interaction.from.asset._id === slide._id"
            class="chip-interaction"
          />
          <router-link v-else :to="`?asset=${interaction.from.asset._id}&site=interactions`" tag="div">
            <v-chip color="primary" link>
              {{ interaction.from.asset.externalId }}
            </v-chip>
          </router-link>
        </div>
        <v-divider class="spacer" />
        <div class="link">
          <v-chip label>
            {{ interaction.type }}
          </v-chip>
        </div>
        <v-divider class="spacer" />
        <div v-if="interaction.to.asset" class="to">
          <div
            v-if="interaction.to.asset && interaction.to.asset._id === slide._id"
            class="chip-interaction"
          />
          <router-link v-else :to="`?asset=${interaction.to.asset._id}&site=interactions`" tag="div">
            <v-chip color="primary" link>
              {{ interaction.to.asset.externalId }}
            </v-chip>
          </router-link>
        </div>
        <!-- <v-divider v-if="interaction.to.asset && interaction.to.return.to && interaction.to.return.to !== null && interaction.to.return.to._id !== interaction.from.asset._id && interaction.to.return.to._id !== interaction.to.asset._id" class="spacer return"/>
        <div  class="to" v-if="interaction.to.return.to && interaction.to.return.to !== null && interaction.to.return.to._id !== interaction.from.asset._id && interaction.to.return.to._id !== interaction.to.asset._id">
          <div class="chip-interaction secondary" v-if="interaction.to.return.to._id ===  slide._id"></div>
          <router-link :to="`/slide/${interaction.to.return.to._id}?site=interactions`" tag="div" v-else>
            <v-chip color="secondary" label link>{{ interaction.to.return.to.externalId }}</v-chip>
          </router-link>
        </div> -->
      </div>
      <v-expand-transition>
        <div class="pa-2 info-box">
          <div v-if="interaction.from.asset && interaction.to.asset" class="layout">
            <v-img
              v-if="interaction.to.asset._id !== slide._id"
              class="full-width"
              :src="interaction.to.asset.asset.png"
            />
            <v-img v-else class="full-width" :src="interaction.from.asset.asset.png">
              <template>
                <div
                  :class="`interaction`"
                  :style="
                    `position: absolute; left: ${interaction.from.coord.x}%; top: ${interaction.from.coord.y}%; width: ${interaction.from.coord.w}%; height: ${interaction.from.coord.h}%;`
                  "
                />
              </template>
            </v-img>
          </div>
          <div class="justify-end">
            <div v-if="interaction.info" class="pt-2 text-italic">
              {{ interaction.info }}
            </div>
            <div v-show="interaction.to.withReturnButton" class="text-bold">
              <b>With Return Button</b>
            </div>
            <div v-show="interaction.to.withPagination" class="text-bold">
              <b>With Pagination</b>
            </div>

            <!-- <div class="pa-2 layout justify-end align-center" v-if="interaction.to.return.to">
              <div class="mr-2"> Action returns to:  </div>
              <router-link :to="`/slide/${interaction.to.return.to._id}?site=interactions`" tag="div">
                <v-chip color="secondary" link label>
                  <span v-if="interaction.to.return.to.externalId === slide.externalId">This slide</span>
                  <span v-else>{{ interaction.to.return.to.externalId }}</span>
                </v-chip>
              </router-link>
            </div> -->
          </div>
        </div>
      </v-expand-transition>
      <div class="subinfos muted mt-2 align-center layout justify-end">
        <v-dialog v-if="interaction" v-model="dialog[index]" content-class="no-shadow" lazy>
          <template v-slot:activator="{ on }">
            <div class="mr-2" style="cursor: pointer" v-on="on">
              Update
            </div>
          </template>
          <create-interaction-dialog update :interaction="interaction" @close="closeDialog(index)" />
        </v-dialog>
        <div style="cursor: pointer; color: red;" @click="deleteInteraction(interaction)">
          Delete
        </div>
        <v-spacer />
        <div class="">
          {{ interaction.createdAt | time }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as moment from 'moment';
import { confirm } from '@/utils/modal';
import { INTERACTION_SET_ACTIVE, TOGGLE_INTERACTION_MODE } from '../../config/constants';
import { UPDATE_ACTIVE_INTERACTION } from '@/config/constants';
import CreateInteractionDialog from '@/components/dialogs/CreateInteractionDialog';
import Vue from 'vue';
export default {
  name: 'InteractionView',
  components: { CreateInteractionDialog },
  filters: {
    time(t) {
      return moment(t).fromNow();
    }
  },
  data() {
    return {
      hover: false,
      dialog: []
    };
  },
  mounted() {
    this.$store.commit('navigation/showButton', { site: 'sdp', buttonName: 'addInteraction' });
  },
  destroyed() {
    this.$store.commit('navigation/hideButton', { site: 'sdp', buttonName: 'addInteraction' });
  },
  computed: {
    ...mapState('slides', {
      slide: state => state.active
    }),
    ...mapState('interactions', {
      active: state => state.active,
      interactions: state => state.items,
      interactionMode: state => state.interactionMode
    })
  },
  methods: {
    closeDialog(index) {
      Vue.set(this.dialog, index, false);
    },
    setActive(interaction) {
      this.hover = interaction._id;
      if (this.interactionMode === false) {
        this.$store.commit(TOGGLE_INTERACTION_MODE);
      }
      this.$store.commit(INTERACTION_SET_ACTIVE, interaction);
    },
    async deleteInteraction(interaction) {
      this.$store.commit(INTERACTION_SET_ACTIVE, interaction);
      confirm('Delete Interaction', 'You are deleting the interaction, are you sure?', 'Yes', 'No').then(
        async yes => {
          if (!yes) return;
          await this.$store.dispatch(UPDATE_ACTIVE_INTERACTION, { active: false });
        }
      );
    }
  }
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.muted {
  font-weight: bold;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
}

.from-point {
  width: 20px;
}
.return {
  background-color: red;
}

.new-interaction {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  background-color: white;
  z-index: 10;
  position: relative;
}

.interaction {
  position: absolute;
  border: 1px dashed grey;
  background-color: rgba(0, 65, 110, 0.5);
}

.info-box {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  margin-top: -5px;
  z-index: 5;
  position: relative;
}

.top {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.active {
  /*border-top-color: red;*/
}
.full-width {
  width: 100%;
}
.chip-interaction {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  color: white;
  width: 20px !important;
  height: 20px !important;
  background-color: var(--new-blue);
  flex: none !important;
}

.connection-select {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center !important;
  background-color: var(--Light-grey1);
}

.to-slide {
  border-radius: 5px;
  width: 100%;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
